import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const pressFeatures = [
  {
    id: 1,
    publication: 'People',
    category: 'Celebrity Style',
    title: 'Ryan Cabrera Marries WWE Star Alexa Bliss',
    description: 'People Magazine captures the romantic wedding of Ryan Cabrera and WWE star Alexa Bliss — with Joshua Stinnett behind the stunning bridal hair look for the big day.',
    year: '2022',
    type: 'press',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/b0d687bdf315ebde86cd704c1bf1fe9b.jpeg',
    link: 'https://people.com/music/ryan-cabrera-marries-wwe-star-alexa-bliss/',
  },
  {
    id: 2,
    publication: 'Out Magazine',
    category: 'Cover Feature',
    title: 'The LGBTQ+ Dolls of Barbie: Alexandra Shipp, Hari Nef & Scott Evans',
    description: 'Out Magazine\'s cover story on the LGBTQ+ cast of the Barbie film — featuring Joshua\'s client work as Alexandra Shipp, Hari Nef, and Scott Evans grace the iconic cover.',
    year: '2023',
    type: 'magazine',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/99afee370d26e6de116cc49bb972ead1.jpeg',
    link: 'https://www.out.com/out-exclusives/barbie-scott-evans',
  },
  {
    id: 4,
    publication: 'People',
    category: 'Celebrity Style',
    title: 'Paula Abdul Delivers High-Energy Billboard Music Awards Performance After Father\'s Death',
    description: 'People Magazine covers Paula Abdul\'s powerful and emotional Billboard Music Awards performance — styled by Joshua Stinnett — as she took the stage in a stunning tribute following a personal loss.',
    year: '2019',
    type: 'press',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/1c236be1901e8de30bef66564da16adc.jpeg',
    link: 'https://people.com/music/billboard-music-awards-2019-paula-abdul-throwback-performance/',
  },
  {
    id: 5,
    publication: 'People',
    category: 'Celebrity Style',
    title: 'Mischa Barton Poses with \'The Hills\' Costars Audrina Patridge and Stephanie Pratt in Smiling Snap',
    description: 'People Magazine captures the reunion moment as Joshua\'s client Mischa Barton steps out alongside The Hills: New Beginnings co-stars Audrina Patridge and Stephanie Pratt ahead of the show\'s premiere.',
    year: '2019',
    type: 'magazine',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/8bf1ca4c6bcfa78f39413ce48fb64fbf.jpeg',
    link: 'https://people.com/tv/mischa-barton-poses-the-hills-costars-audrina-patridge-stephanie-pratt/',
  },
  {
    id: 6,
    publication: 'Interview Magazine',
    category: 'Culture Feature',
    title: 'Nearly a Decade Later, The Hills Comes Back to Reality',
    description: 'Interview Magazine goes behind the scenes of MTV\'s The Hills: New Beginnings — featuring Joshua\'s client work as the cast reunites for one of the most anticipated reality comebacks of the year.',
    year: '2019',
    type: 'press',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/0bc25c6544cb55f954e4e04896636d91.jpeg',
    link: 'https://www.interviewmagazine.com/culture/back-to-reality-mtv-the-hills-new-beginnings',
  },
  {
    id: 7,
    publication: 'Loudwire',
    category: 'Celebrity Feature',
    title: 'Whitesnake\'s David Coverdale Debuts Striking New Look',
    description: 'Loudwire spotlights David Coverdale\'s bold new haircut — a dramatic transformation for the legendary Whitesnake frontman, styled by Joshua Stinnett.',
    year: '2023',
    type: 'press',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/6673fcbe90dbf27df2d1a1b7c8640e59.jpeg',
    link: 'https://loudwire.com/whitesnake-david-coverdale-new-haircut-2023/',
  },
  {
    id: 8,
    publication: 'People',
    category: 'Celebrity Feature',
    title: 'Paris Jackson & Gabriel Glenn\'s Band The Soundflowers Is Coming to Facebook Watch',
    description: 'People Magazine spotlights Paris Jackson and Gabriel Glenn as their band The Soundflowers lands a Facebook Watch series — featuring Joshua Stinnett\'s work on Paris\'s signature bohemian hair look.',
    year: '2020',
    type: 'press',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/de4ad8eaa52fc83deafd7a2128d932b9.webp',
    link: 'https://people.com/music/paris-jackson-gabriel-glenn-facebook-watch-the-soundflowers/',
  },
  {
    id: 9,
    publication: 'Vogue',
    category: 'Cover Feature',
    title: 'The Hills: New Beginnings — The Women Who Defined a Generation',
    description: 'Vogue spotlights the women of The Hills: New Beginnings — featuring Joshua Stinnett\'s signature hair work on the cast as they return to the spotlight in one of reality TV\'s most iconic comebacks.',
    year: '2019',
    type: 'magazine',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/9fbedd3ffa2da4680ffff333f3a41ab5.jpeg',
    link: 'https://www.vogue.com/projects/13549267/the-hills-new-beginnings-women',
  },
  {
    id: 10,
    publication: 'Attitude Magazine',
    category: 'Cover Feature',
    title: 'Scott Evans: On Barbie, Being Out and Proud, and His Love for Big Bro Captain America',
    description: 'Attitude Magazine\'s July/August 2023 cover story featuring Scott Evans — styled by Joshua Stinnett — as he opens up about his role in Barbie, LGBTQ+ pride, and life in the spotlight.',
    year: '2023',
    type: 'magazine',
    image: 'https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/bcad0d1166cbddda5a65d1b3bfc8c342.webp',
    link: 'https://www.yourcelebritymagazines.com/en-us/collections/attitude/products/attitude-magazine-july-august-2023-scott-evans-chris-evans',
  },
];

const tvFilmWork = [
  {
    id: 1,
    title: 'Award Show Prep',
    type: 'Red Carpet',
    description: 'On-call styling for talent attending major award shows including the Grammys, MTV VMAs, and industry premieres.',
    icon: 'ri-award-line',
  },
  {
    id: 2,
    title: 'Music Video Production',
    type: 'On-Set',
    description: 'Key hair stylist on multiple music video productions for major label artists, delivering editorial-quality looks on tight production timelines.',
    icon: 'ri-music-2-line',
  },
  {
    id: 3,
    title: 'Press Tour Styling',
    type: 'Media',
    description: 'Traveling hair stylist for press tours, late-night appearances, and media junkets — ensuring consistency and polish across multiple looks in a single day.',
    icon: 'ri-tv-2-line',
  },
  {
    id: 4,
    title: 'Editorial Shoots',
    type: 'Print & Digital',
    description: 'Collaborated with photographers and creative directors on editorial shoots for print and digital publications, bringing hair concepts to life on set.',
    icon: 'ri-camera-lens-line',
  },
  {
    id: 5,
    title: 'Brand Campaigns',
    type: 'Commercial',
    description: 'Hair direction for brand campaigns and commercial productions, working alongside art directors to align hair with overall visual identity.',
    icon: 'ri-megaphone-line',
  },
  {
    id: 6,
    title: 'Private Appearances',
    type: 'Events',
    description: 'Discreet, on-location styling for private events, charity galas, and high-profile personal appearances throughout Los Angeles.',
    icon: 'ri-vip-crown-line',
  },
];

const pressInquiryFormUrl = 'https://readdy.ai/api/form/d6i8s8af2chgavhbcph0';

export default function MediaPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState<'all' | 'magazine' | 'press'>('all');
  const [inquiryData, setInquiryData] = useState({ name: '', email: '', organization: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const filtered = activeFilter === 'all' ? pressFeatures : pressFeatures.filter(f => f.type === activeFilter);

  const handleInquiryChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setInquiryData(prev => ({ ...prev, [name]: value }));
  };

  const handleInquirySubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      const body = new URLSearchParams();
      Object.entries(inquiryData).forEach(([k, v]) => body.append(k, v));
      const res = await fetch(pressInquiryFormUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setSubmitStatus('success');
        setInquiryData({ name: '', email: '', organization: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4F3F1' }}>
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || mobileMenuOpen ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-[1400px] mx-auto px-5 md:px-12 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://public.readdy.ai/ai/img_res/431d0d82-5d35-4e5b-9098-9c3881ac0720.png"
              alt="Joshua Stinnett Hair Logo"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-12">
            <Link to="/" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Home</Link>
            <Link to="/services" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Services</Link>
            <Link to="/#gallery" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Gallery</Link>
            <Link to="/#about" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">About</Link>
            <Link to="/media" className="text-sm font-medium tracking-wider uppercase text-[#C9A961] transition-colors">Press</Link>
            <Link to="/#contact" className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Contact</Link>
          </div>

          <a
            href="https://booksy.com/en-us/1714591_joshua-stinnett-hair_hair-salon_101361_west-hollywood"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex bg-[#C9A961] text-white px-8 py-3 rounded-full text-sm font-medium tracking-wide uppercase hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer items-center gap-2"
          >
            Book Now <i className="ri-arrow-right-line"></i>
          </a>

          {/* Mobile */}
          <div className="flex lg:hidden items-center gap-3">
            <a
              href="https://booksy.com/en-us/1714591_joshua-stinnett-hair_hair-salon_101361_west-hollywood"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#C9A961] text-white px-5 py-2 rounded-full text-xs font-medium tracking-wide uppercase whitespace-nowrap cursor-pointer"
            >Book Now</a>
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-100 px-5 py-6 flex flex-col gap-5">
            <Link to="/" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Home</Link>
            <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Services</Link>
            <Link to="/#gallery" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Gallery</Link>
            <Link to="/#about" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">About</Link>
            <Link to="/media" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-[#C9A961]">Press</Link>
            <Link to="/#contact" onClick={() => setMobileMenuOpen(false)} className="text-sm font-medium tracking-wider uppercase text-gray-800 hover:text-[#C9A961] transition-colors">Contact</Link>
          </div>
        )}
      </nav>

      {/* Hero */}
      <section className="pt-20 md:pt-40 pb-6 md:pb-20 px-4 md:px-6 relative" style={{ backgroundColor: '#ECEAE6', backgroundImage: 'url(https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/22427efad05f543d534570106432bf64.png)', backgroundSize: '300px', backgroundRepeat: 'repeat' }}>
        <div className="absolute inset-0 bg-[#ECEAE6]/85"></div>
        <div className="max-w-[1200px] mx-auto text-center relative z-10">
          <div className="inline-block mb-2.5 md:mb-6 px-4 md:px-6 py-1.5 md:py-2 border border-gray-300 rounded-full">
            <span className="text-gray-600 text-[10px] md:text-xs font-medium tracking-widest uppercase">Media &amp; Press</span>
          </div>
          <h1 className="text-xl md:text-6xl lg:text-7xl font-serif mb-2.5 md:mb-6 text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            In the Press
          </h1>
          <p className="text-gray-600 text-[11px] md:text-lg max-w-3xl mx-auto leading-relaxed">
            Features, editorials, and on-set work spanning nearly two decades — from West Hollywood private studio sessions to red carpet stages and magazine pages.
          </p>
        </div>
      </section>

      {/* Press Features */}
      <section className="py-8 md:py-24 px-4 md:px-6" style={{ backgroundColor: '#F4F3F1' }}>
        <div className="max-w-[1200px] mx-auto relative z-10">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-5 md:mb-14 gap-3 md:gap-6">
            <div>
              <h2 className="text-lg md:text-4xl font-serif text-gray-900" style={{ fontFamily: 'Playfair Display, serif' }}>Press &amp; Publications</h2>
              <div className="w-10 md:w-16 h-0.5 md:h-1 bg-[#C9A961] mt-2 md:mt-4"></div>
            </div>
            <div className="flex items-center gap-1 md:gap-2 bg-[#ECEAE6] rounded-full px-1 py-1 self-start sm:self-auto">
              {(['all', 'magazine', 'press'] as const).map(f => (
                <button
                  key={f}
                  onClick={() => setActiveFilter(f)}
                  className={`px-3 md:px-6 py-1.5 md:py-2 rounded-full text-[10px] md:text-sm font-medium tracking-wide uppercase transition-all whitespace-nowrap cursor-pointer ${
                    activeFilter === f
                      ? 'bg-[#C9A961] text-white shadow'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {f === 'all' ? 'All' : f === 'magazine' ? 'Magazine' : 'Press'}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-8">
            {filtered.map(item => (
              <article
                key={item.id}
                className="rounded-xl md:rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 group"
                style={{ backgroundColor: '#ECEAE6' }}
              >
                <div className="overflow-hidden" style={{ height: 'clamp(48px, 33vw, 220px)' }}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover md:object-top transition-transform duration-500 group-hover:scale-105"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <div className="p-2.5 md:p-8">
                  <div className="flex items-center justify-between mb-1 md:mb-4">
                    <span className="text-[#C9A961] text-[9px] md:text-xs font-medium tracking-widest uppercase">{item.category}</span>
                    <span className="text-gray-400 text-[9px] md:text-xs">{item.year}</span>
                  </div>
                  <div className="text-gray-500 text-[9px] md:text-sm font-semibold tracking-wide uppercase mb-0.5 md:mb-2">{item.publication}</div>
                  <h3 className="text-[11px] md:text-xl font-semibold text-gray-900 mb-1 md:mb-3 leading-snug" style={{ fontFamily: 'Playfair Display, serif' }}>
                    {item.title}
                  </h3>
                  <p className="text-gray-600 text-[10px] md:text-sm leading-relaxed mb-2 md:mb-6 line-clamp-2 md:line-clamp-none">{item.description}</p>
                  <a
                    href={item.link}
                    rel="nofollow noopener noreferrer"
                    className="inline-flex items-center gap-1 md:gap-2 text-[#C9A961] text-[10px] md:text-sm font-medium hover:gap-3 transition-all cursor-pointer"
                  >
                    Read Feature
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* TV, Film & On-Set Work */}
      <section className="py-8 md:py-24 px-4 md:px-6" style={{ backgroundColor: '#ECEAE6' }}>
        <div className="max-w-[1200px] mx-auto relative z-10">
          <div className="text-center mb-6 md:mb-16">
            <div className="inline-block mb-2.5 md:mb-4 px-4 md:px-6 py-1.5 md:py-2 border border-gray-300 rounded-full">
              <span className="text-gray-600 text-[10px] md:text-xs font-medium tracking-widest uppercase">On-Set &amp; On-Stage</span>
            </div>
            <h2 className="text-lg md:text-4xl font-serif text-gray-900 mb-1.5 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Production &amp; Event Work
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed text-[11px] md:text-base">
              From music video sets to award show green rooms — a look at the range of work beyond the studio chair.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
            {tvFilmWork.map(item => (
              <div
                key={item.id}
                className="rounded-xl md:rounded-2xl p-4 md:p-8 hover:shadow-lg transition-all duration-300 group"
                style={{ backgroundColor: '#F4F3F1' }}
              >
                <div className="w-9 h-9 md:w-14 md:h-14 rounded-full bg-gray-100 flex items-center justify-center mb-3 md:mb-6 group-hover:bg-[#C9A961] transition-colors">
                  <i className={`${item.icon} text-base md:text-2xl text-gray-600 group-hover:text-white transition-colors`}></i>
                </div>
                <div className="text-[#C9A961] text-[10px] md:text-xs font-medium tracking-widest uppercase mb-1 md:mb-2">{item.type}</div>
                <h3 className="text-sm md:text-xl font-semibold text-gray-900 mb-1.5 md:mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
                  {item.title}
                </h3>
                <p className="text-gray-600 text-[11px] md:text-sm leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Image Strip */}
      <section className="py-8 md:py-24 px-4 md:px-6" style={{ backgroundColor: '#F4F3F1' }}>
        <div className="max-w-[1400px] mx-auto relative z-10">
          <div className="text-center mb-5 md:mb-14">
            <h2 className="text-lg md:text-4xl font-serif text-gray-900 mb-1.5 md:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
              Behind the Scenes
            </h2>
            <p className="text-gray-600 text-[11px] md:text-base">A glimpse into the work — on set, on location, and behind the chair.</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-5">
            {[
              { src: "https://public.readdy.ai/ai/img_res/cc4bbf21c2b8aea9d3f15507fd2b2923.jpg", alt: "Behind the scenes award show prep" },
              { src: "https://readdy.ai/api/search-image?query=music%20video%20set%20hair%20styling%20on%20location%20professional%20crew%20editorial%20fashion%20shoot%20vibrant%20creative%20atmosphere%20warm%20tones&width=400&height=640&seq=bts2&orientation=portrait", alt: "Music video set styling" },
              { src: "https://readdy.ai/api/search-image?query=editorial%20magazine%20photo%20shoot%20hair%20styling%20model%20platinum%20blonde%20luxury%20fashion%20photography%20studio%20neutral%20background%20elegant&width=400&height=640&seq=bts3&orientation=portrait", alt: "Editorial magazine shoot" },
              { src: "https://readdy.ai/api/search-image?query=private%20luxury%20hair%20salon%20studio%20West%20Hollywood%20warm%20neutral%20interior%20professional%20styling%20chair%20tools%20elegant%20minimalist%20atmosphere&width=400&height=640&seq=bts4&orientation=portrait", alt: "Private studio session" },
            ].map((img) => (
              <div key={img.alt} className="rounded-xl overflow-hidden group cursor-pointer" style={{ height: 'clamp(110px, 30vw, 320px)' }}>
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Press Inquiry Form */}
      <section className="py-8 md:py-24 px-4 md:px-6 relative" style={{ backgroundColor: '#1A1A1A', backgroundImage: 'url(https://static.readdy.ai/image/9da899e6632b3980025b2970c57bca5e/22427efad05f543d534570106432bf64.png)', backgroundSize: '300px', backgroundRepeat: 'repeat' }}>
        <div className="absolute inset-0 bg-[#1A1A1A]/88"></div>
        <div className="max-w-[900px] mx-auto relative z-10">
          <div className="text-center mb-6 md:mb-14">
            <h2 className="text-xl md:text-5xl font-serif mb-2.5 md:mb-4 text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              Press Inquiries
            </h2>
            <div className="w-12 md:w-20 h-0.5 md:h-1 bg-[#C9A961] mx-auto mb-2.5 md:mb-6"></div>
            <p className="text-gray-400 text-[11px] md:text-lg max-w-xl mx-auto">
              For media features, editorial collaborations, or interview requests, reach out below.
            </p>
          </div>

          {submitStatus === 'success' && (
            <div className="mb-6 p-3 md:p-4 bg-green-500/20 border border-green-500 rounded-lg text-green-400 text-center text-xs md:text-sm">
              Thank you for reaching out — we'll be in touch shortly.
            </div>
          )}
          {submitStatus === 'error' && (
            <div className="mb-6 p-3 md:p-4 bg-red-500/20 border border-red-500 rounded-lg text-red-400 text-center text-xs md:text-sm">
              Something went wrong. Please try again.
            </div>
          )}

          <form onSubmit={handleInquirySubmit} data-readdy-form id="press-inquiry-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 mb-3 md:mb-6">
              <input
                type="text"
                name="name"
                value={inquiryData.name}
                onChange={handleInquiryChange}
                placeholder="Your Name"
                required
                className="w-full bg-[#2A2A2A] text-white px-4 md:px-6 py-3 md:py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-gray-500 text-xs md:text-sm"
              />
              <input
                type="email"
                name="email"
                value={inquiryData.email}
                onChange={handleInquiryChange}
                placeholder="Email Address"
                required
                className="w-full bg-[#2A2A2A] text-white px-4 md:px-6 py-3 md:py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-gray-500 text-xs md:text-sm"
              />
            </div>
            <input
              type="text"
              name="organization"
              value={inquiryData.organization}
              onChange={handleInquiryChange}
              placeholder="Publication / Organization"
              className="w-full bg-[#2A2A2A] text-white px-4 md:px-6 py-3 md:py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-gray-500 text-xs md:text-sm mb-3 md:mb-6"
            />
            <textarea
              name="message"
              value={inquiryData.message}
              onChange={handleInquiryChange}
              placeholder="Tell us about your project or inquiry..."
              required
              maxLength={500}
              rows={4}
              className="w-full bg-[#2A2A2A] text-white px-4 md:px-6 py-3 md:py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-gray-500 text-xs md:text-sm mb-3 md:mb-6 resize-none"
            ></textarea>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#C9A961] text-white py-3 md:py-5 rounded-full text-xs md:text-sm font-medium tracking-wide uppercase hover:bg-[#B89851] transition-all flex items-center justify-center gap-2 md:gap-3 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? 'Sending...' : 'Submit Inquiry'}
              <i className="ri-send-plane-line"></i>
            </button>
          </form>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black text-white py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-10 gap-10 md:gap-12 mb-10 md:mb-12">
            <div className="md:col-span-4">
              <Link to="/" className="flex items-center gap-3 mb-5 md:mb-6">
                <img
                  src="https://public.readdy.ai/ai/img_res/431d0d82-5d35-4e5b-9098-9c3881ac0720.png"
                  alt="Joshua Stinnett Hair Logo"
                  className="h-10 w-auto object-contain"
                />
              </Link>
              <p className="text-gray-400 leading-relaxed mb-4 text-sm">
                Celebrity hairstylist and color specialist based in West Hollywood. Nearly two decades of experience in precision cutting, advanced blonding, and luxury client service.
              </p>
              <div className="mb-5 space-y-1">
                <a href="mailto:JoshuaStinnett85@gmail.com" className="flex items-center gap-2 text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer">
                  <i className="ri-mail-line text-[#C9A961]"></i>
                  JoshuaStinnett85@gmail.com
                </a>
                <a href="tel:3107708491" className="flex items-center gap-2 text-gray-400 hover:text-[#C9A961] transition-colors text-sm cursor-pointer">
                  <i className="ri-phone-line text-[#C9A961]"></i>
                  310.770.8491
                </a>
              </div>
              <div className="flex items-center gap-4">
                <a href="https://www.instagram.com/joshuastinnett?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer">
                  <i className="ri-facebook-fill"></i>
                </a>
                <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer">
                  <i className="ri-pinterest-line"></i>
                </a>
                <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full border-2 border-white/30 flex items-center justify-center hover:border-[#C9A961] hover:text-[#C9A961] transition-all cursor-pointer">
                  <i className="ri-tiktok-line"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-white text-sm font-medium tracking-widest uppercase mb-5">Quick Links</h4>
              <ul className="space-y-3">
                <li><Link to="/services" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Services</Link></li>
                <li><Link to="/#gallery" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Gallery</Link></li>
                <li><Link to="/#about" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">About</Link></li>
                <li><Link to="/media" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Press</Link></li>
                <li><Link to="/#contact" className="text-gray-400 hover:text-[#C9A961] transition-colors cursor-pointer text-sm">Booking</Link></li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-white text-sm font-medium tracking-widest uppercase mb-5">Stay Updated</h4>
              <p className="text-gray-400 mb-4 text-sm">Subscribe for styling tips and exclusive offers</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 bg-[#2A2A2A] text-white px-4 py-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C9A961] placeholder-gray-500 text-sm min-w-0"
                />
                <button className="bg-[#C9A961] text-white px-5 py-3 rounded-lg hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer flex-shrink-0">
                  <i className="ri-send-plane-fill"></i>
                </button>
              </div>
              <p className="text-gray-500 text-xs mt-4">We respect your privacy</p>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm text-center">© 2025 Joshua Stinnett. All rights reserved.</p>
            <div className="flex items-center gap-4 text-sm flex-wrap justify-center">
              <a href="#" className="text-gray-500 hover:text-[#C9A961] transition-colors cursor-pointer">Privacy Policy</a>
              <span className="text-gray-700">·</span>
              <a href="#" className="text-gray-500 hover:text-[#C9A961] transition-colors cursor-pointer">Terms</a>
              <span className="text-gray-700">·</span>
              <a href="#" className="text-gray-500 hover:text-[#C9A961] transition-colors cursor-pointer">Sitemap</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
